<div class="client-settlement-container">
  <!-- Header -->
  <!-- <div class="settlement-header">
    <h2>Client Settlement</h2>
    <p class="subtitle">Map credit and debit modules for client settlement</p>
  </div> -->

  <!-- Primary Information Section -->
  <p-card class="primary-info-card">
    <ng-template pTemplate="header">
      <div class="card-header">
        <h3>Primary Information</h3>
      </div>
    </ng-template>

    <app-dynamic-form [data]="primaryFields" [formGroup]="primaryForm" [viewMode]="false"
      (searchQuery)="onSearchQuery($event)" (fieldChanged)="onFieldChanged($event)"></app-dynamic-form>
  </p-card>

  <!-- Credit and Debit Modules Section -->
  <div class="modules-container" *ngIf="selectedClient && selectedSubsidiary">
    <!-- Credit Modules (Left Side) -->
    <div class="credit-modules-section">
      <!-- Unified Credit Modules Table -->
      <p-card class="module-card">
        <ng-template pTemplate="header">
          <div class="card-header">
            <h4>{{ creditModulesConfig.credit_modules.title }}</h4>
            <p-tag [value]="allCreditModules.length + ' records'" severity="info"></p-tag>
          </div>
        </ng-template>

        <app-item-dynamic-form *ngIf="!loadingCreditModules && lastCreditModulesPage === creditModulesPage" [data]="creditModulesConfig.credit_modules.fields"
          [formGroup]="creditModulesForm" [tableKey]="'credit_modules'" [viewMode]="false"
          [showSelectionCheckbox]="true" [showAddRemoveButtons]="false"
          [showSerialNumber]="true"
          [redirectQueryParamsResolver]="resolveRedirectQueryParams"
          (selectionChanged)="onSelectionChanged($event, 'credit')"></app-item-dynamic-form>

        <div *ngIf="loadingCreditModules" class="loading-state">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Loading amounts receivable...</p>
        </div>

        <div *ngIf="!loadingCreditModules && creditModulesConfig.credit_modules.data.length === 0" class="empty-state">
          <i class="pi pi-inbox" style="font-size: 2rem"></i>
          <p>No unsettled amounts receivable found</p>
        </div>

        <ng-template pTemplate="footer">
          <p-paginator
            *ngIf="!loadingCreditModules && creditModulesTotalCount > 0"
            [rows]="creditModulesLimit"
            [totalRecords]="creditModulesTotalCount"
            [first]="(creditModulesPage - 1) * creditModulesLimit"
            dropdownAppendTo="body"
            (onPageChange)="onCreditModulesPageChange($event)"
          ></p-paginator>
        </ng-template>
      </p-card>
    </div>

    <!-- Debit Modules (Right Side) -->
    <div class="debit-modules-section">

      <!-- Unified Debit Modules Table -->
      <p-card class="module-card">
        <ng-template pTemplate="header">
          <div class="card-header">
            <h4>{{ debitModulesConfig.debit_modules.title }}</h4>
            <p-tag [value]="allDebitModules.length + ' records'" severity="success"></p-tag>
          </div>
        </ng-template>

        <app-item-dynamic-form *ngIf="!loadingDebitModules && lastDebitModulesPage === debitModulesPage" [data]="debitModulesConfig.debit_modules.fields"
          [formGroup]="debitModulesForm" [tableKey]="'debit_modules'" [viewMode]="false" [showSelectionCheckbox]="true"
          [showAddRemoveButtons]="false"
          [showSerialNumber]="true"
          [redirectQueryParamsResolver]="resolveRedirectQueryParams"
          (selectionChanged)="onSelectionChanged($event, 'debit')"></app-item-dynamic-form>

        <div *ngIf="loadingDebitModules" class="loading-state">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Loading payments received...</p>
        </div>

        <div *ngIf="!loadingDebitModules && debitModulesConfig.debit_modules.data.length === 0" class="empty-state">
          <i class="pi pi-inbox" style="font-size: 2rem"></i>
          <p>No payments found</p>
        </div>

        <ng-template pTemplate="footer">
          <p-paginator
            *ngIf="!loadingDebitModules && debitModulesTotalCount > 0"
            [rows]="debitModulesLimit"
            [totalRecords]="debitModulesTotalCount"
            [first]="(debitModulesPage - 1) * debitModulesLimit"
            dropdownAppendTo="body"
            (onPageChange)="onDebitModulesPageChange($event)"
          ></p-paginator>
        </ng-template>
      </p-card>
    </div>
  </div>

  <!-- Auto-Apply Mappings Section -->
  <p-card class="auto-apply-card" *ngIf="autoApplyMappings.length > 0">
    <ng-template pTemplate="header">
      <div class="card-header">
        <h3>Auto-Apply Mappings</h3>
        <p-tag [value]="autoApplyMappings.length + ' mappings'" severity="warn"></p-tag>
      </div>
    </ng-template>

    <!-- Use ItemDynamicForm for consistent styling -->
    <app-item-dynamic-form 
      [formGroup]="autoApplyMappingsForm" 
      [data]="autoApplyMappingsConfig.mappings.fields"
      [tableKey]="'mappings'" 
      [viewMode]="true"
      [showAddRemoveButtons]="false"
      [showSerialNumber]="true"
      [showSelectionCheckbox]="false"
      [redirectQueryParamsResolver]="resolveRedirectQueryParams">
    </app-item-dynamic-form>

    <div class="table-summary">
      <strong>Total Mapped Amount: </strong>
      <span class="total-amount">
        {{ formatCurrency(getTotalMappedAmount()) }}
      </span>
    </div>

    <ng-template pTemplate="footer">
      <div class="card-footer">
        <p-button label="Reset" icon="pi pi-refresh" severity="secondary" (onClick)="resetForm()"
          [disabled]="isSubmitting"></p-button>
        <p-button label="Submit Settlement Mappings" severity="primary" (onClick)="onSubmit()"
          [loading]="isSubmitting"></p-button>
      </div>
    </ng-template>
  </p-card>

  <!-- No Selection Message -->
  <div class="no-selection-message" *ngIf="selectedClient && selectedSubsidiary && autoApplyMappings.length === 0">
    <p-card>
      <div class="info-message">
        <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--primary-color)"></i>
        <p>Select rows from Amounts Receivable (left) and Payments Received (right) to generate settlement mappings.</p>
      </div>
    </p-card>
  </div>

  <!-- Client Selection Required Message -->
  <div class="no-selection-message" *ngIf="!selectedClient">
    <p-card>
      <div class="info-message">
        <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--primary-color)"></i>
        <p>Please select a Client to load available subsidiaries.</p>
      </div>
    </p-card>
  </div>

  <!-- Subsidiary Selection Required Message -->
  <div class="no-selection-message" *ngIf="selectedClient && !selectedSubsidiary && allSubsidiaries.length > 0">
    <p-card>
      <div class="info-message">
        <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--primary-color)"></i>
        <p>Please select a Subsidiary to view settlement data.</p>
      </div>
    </p-card>
  </div>

  <!-- No Subsidiaries Found Message -->
  <div class="no-selection-message" *ngIf="selectedClient && allSubsidiaries.length === 0">
    <p-card>
      <div class="info-message">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: var(--orange-500)"></i>
        <p>No subsidiaries found for the selected client.</p>
      </div>
    </p-card>
  </div>
</div>
